module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_619933.29c878a8.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetInRecargas/FormatoSimplificado_619933.pdf
// module id = 889
// module chunks = 0